import { createSlice } from '@reduxjs/toolkit';

import { FUEL_TYPES } from 'config/app-config';

export type ConsumptionState = {
  [FUEL_TYPES.ELECTRIC]?: null | string;
  [FUEL_TYPES.GAS]?: null | string;
};

export const initialState: ConsumptionState = Object.values(FUEL_TYPES).reduce(
  (acc, value) => {
    return {
      ...acc,
      [value]: null
    };
  },
  {}
);

export const slice = createSlice({
  name: 'consumption',
  initialState,
  reducers: {
    setConsumption: (state, { payload }) => {
      Object.entries(payload).forEach(([key, value]) => {
        state[key] = value;
      });
    },
    setInitialState: (state) => {
      state[FUEL_TYPES.ELECTRIC] = null;
      state[FUEL_TYPES.GAS] = null;
    }
  }
});

export const { setConsumption, setInitialState } = slice.actions;

export const selectSlice = (state) => state[slice.name];

export default slice.reducer;
